/*
 *
 * SavingWallet constants
 *
 */

const constantKey = 'app/containers/SavingWallet';

const savingWalletConstants = {
  GET_WALLET_SUMMARY: `${constantKey}/GET_WALLET_SUMMARY`,
  GET_WALLET_SUMMARY_SUCCESS: `${constantKey}/GET_WALLET_SUMMARY_SUCCESS`,
  GET_WALLET_SUMMARY_ERROR: `${constantKey}/GET_WALLET_SUMMARY_ERROR`,

  GET_WALLET_TRANSACTIONS: `${constantKey}/GET_WALLET_TRANSACTIONS`,
  GET_WALLET_TRANSACTIONS_SUCCESS: `${constantKey}/GET_WALLET_TRANSACTIONS_SUCCESS`,
  GET_WALLET_TRANSACTIONS_ERROR: `${constantKey}/GET_WALLET_TRANSACTIONS_ERROR`,

  SET_PREVIOUS_POINTS: `${constantKey}/SET_PREVIOUS_POINTS`,
  SHOW_MILESTONE_CELEBRATION: `${constantKey}/SHOW_MILESTONE_CELEBRATION`,
  HIDE_MILESTONE_CELEBRATION: `${constantKey}/HIDE_MILESTONE_CELEBRATION`,
};

export default savingWalletConstants;
